import {useMemo} from "react";
import {css, Theme, useTheme} from "@emotion/react";
import {parseISO} from "date-fns";

import {
    borderRadius,
    color,
    display,
    flex,
    flexAbsoluteCenter,
    flexAlignCenter,
    flexDirection,
    mt,
    onDesktop,
    pb,
    position,
    positionRelative,
    w100,
    zIndex
} from "@pg-design/helpers-css";
import {InfoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {monthWhenVerbose} from "@pg-mono/string-utils";
import {PRICES_CITIES} from "@pg-rp/navigation";

import {getCitiesData} from "../../utils/get_cities_data";
import {SingleBar} from "./SingleBar";

export const BarChart = () => {
    const citiesData = getCitiesData();

    const theme = useTheme();

    const total: number = useMemo(() => {
        if (citiesData) {
            return [...citiesData].sort((prev, next) => next.avgPriceM2 - prev.avgPriceM2)[0].avgPriceM2;
        }
        return 0;
    }, [citiesData]);

    const values: IChartValues = useMemo(() => {
        const newValues = initialChartValues;

        if (citiesData) {
            for (const city of citiesData) {
                newValues[city.slug].value = city.avgPriceM2;
            }
        }

        return newValues;
    }, [citiesData]);

    const date = parseISO(citiesData[0].date);
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return (
        <div css={[flexAbsoluteCenter, flexDirection("column")]}>
            <div css={chartWrapper}>
                <div css={chartHolder}>
                    <div css={chart}>
                        {Object.entries(values).map(([slug, values], i) => (
                            <SingleBar key={slug} citySlug={slug} total={total} animationDelay={(i + 1) / 4} {...values} />
                        ))}
                    </div>
                </div>

                <div css={chartInfo}>
                    <InfoIcon fill="orange" size="2" />

                    <Text css={color(theme.colors.gray[700])} variant="info_txt_1">
                        {`Średnia cena za metr kwadratowy w ${citiesData.length} największych miastach w ${monthWhenVerbose(month)} ${year}`}
                    </Text>
                </div>
            </div>
        </div>
    );
};

interface IChartValues {
    [key: string]: {
        name: string;
        hsl: [number, number, number];
        value: number;
    };
}

const initialChartValues: IChartValues = PRICES_CITIES.reduce((acc, curr) => {
    acc[curr.slug] = {name: curr.name, hsl: curr.hsl, value: 0};
    return acc;
}, {} as IChartValues);

const chartWrapper = (theme: Theme) => css`
    ${positionRelative};
    width: 95%;

    &:after {
        content: "";
        ${position("absolute")};
        ${w100};
        height: 75%;
        inset: 0;
        transform: translateY(5%);
        background: repeating-linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0) 60px, #e0e0e0 60px, #e0e0e0 61px);
        ${zIndex(9)};
    }

    @media (min-width: ${theme.breakpoints.lg}) {
        &:after {
            transform: translateY(12%);
        }
    }
`;

const chartHolder = css`
    ${positionRelative};
    ${w100};
    ${flex("end", "center")};
    ${zIndex(10)};
    height: 450px;
`;

const chart = (theme: Theme) => css`
    ${display("grid")};
    ${w100};
    ${pb(2)};
    grid-template-columns: repeat(14, 25%);
    align-items: end;
    overflow-y: hidden;
    overflow-x: auto;

    &::-webkit-scrollbar {
        height: 8px;
    }

    &::-webkit-scrollbar-track {
        ${borderRadius(1)};
        background: ${theme.colors.gray[400]};
    }

    &::-webkit-scrollbar-thumb {
        ${borderRadius(1)};
        background: ${theme.colors.gray[600]};
    }

    @media (min-width: ${theme.breakpoints.sm}) {
        grid-template-columns: repeat(14, 15%);
    }

    @media (min-width: ${theme.breakpoints.md}) and (max-width: ${theme.breakpoints.numeric.lg - 1}px) {
        grid-template-columns: repeat(14, 10%);
    }

    @media (min-width: ${theme.breakpoints.lg}) {
        ${pb(0)};
        grid-template-columns: repeat(14, 7%);
        justify-content: center;
    }
`;

const chartInfo = css`
    ${flexAlignCenter};
    ${mt(2)};
    gap: 1.6rem;

    ${onDesktop(mt(6))};
`;
import {useMemo} from "react";
import {css, Theme, useTheme} from "@emotion/react";
import {parseISO} from "date-fns";

import {
    borderRadius,
    color,
    display,
    flex,
    flexAbsoluteCenter,
    flexAlignCenter,
    flexDirection,
    mt,
    onDesktop,
    pb,
    position,
    positionRelative,
    w100,
    zIndex
} from "@pg-design/helpers-css";
import {InfoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {monthWhenVerbose} from "@pg-mono/string-utils";
import {PRICES_CITIES} from "@pg-rp/navigation";

import {getCitiesData} from "../../utils/get_cities_data";
import {SingleBar} from "./SingleBar";

export const BarChart = () => {
    const citiesData = getCitiesData();

    const theme = useTheme();

    const total: number = useMemo(() => {
        if (citiesData) {
            return [...citiesData].sort((prev, next) => next.avgPriceM2 - prev.avgPriceM2)[0].avgPriceM2;
        }
        return 0;
    }, [citiesData]);

    const values: IChartValues = useMemo(() => {
        const newValues = initialChartValues;

        if (citiesData) {
            for (const city of citiesData) {
                newValues[city.slug].value = city.avgPriceM2;
            }
        }

        return newValues;
    }, [citiesData]);

    const date = parseISO(citiesData[0].date);
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return (
        <div css={[flexAbsoluteCenter, flexDirection("column")]}>
            <div css={chartWrapper}>
                <div css={chartHolder}>
                    <div css={chart}>
                        {Object.entries(values).map(([slug, values], i) => (
                            <SingleBar key={slug} citySlug={slug} total={total} animationDelay={(i + 1) / 4} {...values} />
                        ))}
                    </div>
                </div>

                <div css={chartInfo}>
                    <InfoIcon fill="orange" size="2" />

                    <Text css={color(theme.colors.gray[700])} variant="info_txt_1">
                        {`Średnia cena za metr kwadratowy w ${citiesData.length} największych miastach w ${monthWhenVerbose(month)} ${year}`}
                    </Text>
                </div>
            </div>
        </div>
    );
};

interface IChartValues {
    [key: string]: {
        name: string;
        hsl: [number, number, number];
        value: number;
    };
}

const initialChartValues: IChartValues = PRICES_CITIES.reduce((acc, curr) => {
    acc[curr.slug] = {name: curr.name, hsl: curr.hsl, value: 0};
    return acc;
}, {} as IChartValues);

const chartWrapper = (theme: Theme) => css`
    ${positionRelative};
    width: 95%;

    &:after {
        content: "";
        ${position("absolute")};
        ${w100};
        height: 75%;
        inset: 0;
        transform: translateY(5%);
        background: repeating-linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0) 60px, #e0e0e0 60px, #e0e0e0 61px);
        ${zIndex(9)};
    }

    @media (min-width: ${theme.breakpoints.lg}) {
        &:after {
            transform: translateY(12%);
        }
    }
`;

const chartHolder = css`
    ${positionRelative};
    ${w100};
    ${flex("end", "center")};
    ${zIndex(10)};
    height: 450px;
`;

const chart = (theme: Theme) => css`
    ${display("grid")};
    ${w100};
    ${pb(2)};
    grid-template-columns: repeat(14, 25%);
    align-items: end;
    overflow-y: hidden;
    overflow-x: auto;

    &::-webkit-scrollbar {
        height: 8px;
    }

    &::-webkit-scrollbar-track {
        ${borderRadius(1)};
        background: ${theme.colors.gray[400]};
    }

    &::-webkit-scrollbar-thumb {
        ${borderRadius(1)};
        background: ${theme.colors.gray[600]};
    }

    @media (min-width: ${theme.breakpoints.sm}) {
        grid-template-columns: repeat(14, 15%);
    }

    @media (min-width: ${theme.breakpoints.md}) and (max-width: ${theme.breakpoints.numeric.lg - 1}px) {
        grid-template-columns: repeat(14, 10%);
    }

    @media (min-width: ${theme.breakpoints.lg}) {
        ${pb(0)};
        grid-template-columns: repeat(14, 7%);
        justify-content: center;
    }
`;

const chartInfo = css`
    ${flexAlignCenter};
    ${mt(2)};
    gap: 1.6rem;

    ${onDesktop(mt(6))};
`;
